
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai-it-helpdesk",
      function () {
        return require("private-next-pages/solutions/ai-it-helpdesk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ai-it-helpdesk"])
      });
    }
  